import { render, staticRenderFns } from "./DashboardPlanejamento.vue?vue&type=template&id=7f595411&lang=html&"
import script from "./DashboardPlanejamento.vue?vue&type=script&lang=js&"
export * from "./DashboardPlanejamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/dashboard/cadeia/DashboardPlanejamento.vue
// module id = 1180
// module chunks = 28